/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';

export default declareEntity({
    name: "warningLogs",
    graphQL: "WarningLog",
    entity: 'warningLogs',
    storageType: 'central',
    description: "WarningLogs of parsing errors",
    userEditable: false,
    fields: (types) => { return {
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true
        },
        channelDef: {
            name: "Application Def",
            type: "relation",
            to: () => types['channelDefs'],
            required: true
        },
        sourceDef: {
            name: "SourceDef",
            type: "relation",
            to: () => types['sourceDefs'],
            required: true,
            relativeTo: ['channelDef'],
        },
        event: {
            name: "Event",
            type: "relation",
            to: () => types['events'],
            required: true,
            relativeTo: ['channel'],
        },
        warningType: {
            name: "Warning Type",
            type: "enum",
            values: {
                "invalid-value": {
                    name: "Invalid value"
                },
                "unknown-field": {
                    name: "Unknown field"
                },
            }
        },
        message: {
            name: "Message",
            type: "string"
        },
        data: {
            name: "Data",
            type: "object",
            defaultValue: {},
            userEditable: false,
            offload: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; }
});
